import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Favorites, FavoritesComponent } from '../models/favorites.model';

@Injectable({
	providedIn: 'root'
})
export class FavoritesService {


	/**
	 * Url to get a list of not processed Notifications
	 */
	 private API_COMPONENT_URL = environment.ipserver + 'AnA-backend/private/favorites';
	 private API_COMPONENTS_URL = environment.ipserver + 'AnA-backend/private/component';
	 constructor(private http: HttpClient) { }

    /**
     * Method that register favorites rest service
     * @author Castor Transformación Digital - Alejandro Segura
     * @since 2020-07-20
     * @param component: The component
     * @return Observable with a json that contains a list of components
     */
	 public register(component: Favorites): Observable<any> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_COMPONENT_URL}/register`, component, { headers: httpHeaders, responseType: type });
    }

	/**
     * Method that remove favorites rest service
     * @author Castor Transformación Digital - Alejandro Segura
     * @since 2020-07-20
     * @param component: The component
     * @return Observable with a json that contains a list of components
     */
	 public remove(component: Favorites): Observable<any> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
		let options = {
			headers: new HttpHeaders({
			  'Content-Type': 'application/json',
			}),
			body: {username: component.username , idComponent: component.idComponent},
		  };
        return this.http.delete<any>(`${this.API_COMPONENT_URL}/remove`,  options);
    }

	/**
     * Method that obtains a component by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @param id: The component id
     * @return Observable with a json that contains a list of components
     */
	 public findByUser(user: string): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		const paramsForReq = new HttpParams()
		.set('user', user);
        return this.http.get<any>(`${this.API_COMPONENT_URL}/findByUser`,  { params: paramsForReq });
    }
	/**
     * Method that obtains a component by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @param id: The component id
     * @return Observable with a json that contains a list of components
     */
	 public validateComponent(user: string,componentId:string): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		const paramsForReq = new HttpParams()
		.set('user', user)
		.set('componentId', componentId);
        return this.http.get<any>(`${this.API_COMPONENT_URL}/validateComponent`,  { params: paramsForReq });
    }
	/**
     * Method that obtains a component by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @param id: The component id
     * @return Observable with a json that contains a list of components
     */
	 public findComponentByUrl(componentUrl: string): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		const paramsForReq = new HttpParams()
		.set('componentUrl', componentUrl)

        return this.http.get<any>(`${this.API_COMPONENTS_URL}/findByUrl`,  { params: paramsForReq });
    }


}
